import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const GuidedDemoArchiveInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();
  const onClose = () => context.closeInfoBubbles(OnboardingTipTypesEnum.GUIDED_DEMO_ARCHIVE);

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.GUIDED_DEMO_ARCHIVE}
      position="right"
      targetRef={targetRef}
      isInteractive
    >
      <InfoBubbleContent>
        <Trans id="infobubble-guideddemoarchive-description">
          The conversation moved into &quot;Archived&quot;.{' '}
          <strong>If you get a new reply, you&apos;ll see it in &quot;Open&quot; again!</strong>
        </Trans>
        <InfoBubbleFooterActions>
          <Button
            onClick={onClose}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-guideddemoarchive-cta">Got it</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
